import * as z from 'zod';
import { dateToStringSchema } from '@soundxyz/utils/constants/schema';

export const numericNullish = z
  .union([z.string(), z.number()])
  .transform(v => {
    const stringNum = v.toString();
    return stringNum ? parseInt(stringNum, 10) : null;
  })
  .nullish();

export const numericString = z.number().nullish().or(z.string());

export const nullableNumber = z.number().nullable();

export const optionalNumber = z.number().optional();

export const nullableDate = z.date().nullable();

export const stringToDate = dateToStringSchema.pipe(z.date());

export const nullableStringDate = stringToDate.nullable();

export function isAtLeastOneHourInFuture(date1: Date, date2: Date): boolean {
  // Calculate the time difference in milliseconds
  const timeDifference = date1.getTime() - date2.getTime();

  // Define the number of milliseconds in an hour
  const oneHourInMilliseconds = 60 * 60 * 1000;

  // Check if the time difference is greater than or equal to one hour
  return timeDifference >= oneHourInMilliseconds;
}
